import {Controller} from '@hotwired/stimulus';

/**
 * Sélecteur d'état d'un contenu : le bouton montre le badge de la réponse choisie dans son panneau (radios). Chaque
 * badge du bouton porte la valeur qu'il représente (`data-value`).
 */
export default class extends Controller {
  static targets = ['badge'];

  connect() {
    this.update();
  }

  update() {
    const checked = this.element.querySelector('input[type=radio]:checked');

    this.badgeTargets.forEach((badge) => {
      badge.hidden = badge.dataset.value !== checked?.value;
    });
  }
}
